import type { Metadata } from "next";
import AdminBrandDetail from "@/Component/Admin/AdminBrandsListing/AdminBrandDetail";

export const metadata: Metadata = {
    title: "Brand Details | Connector Club",
    description: "",
};

const AdminBrandDetailsPage = async ({ params }: { params: Promise<{ UserSlug: string }>; }) => {
    const resolvedParams = await params;
    const userSlug = Array.isArray(resolvedParams.UserSlug)
        ? resolvedParams.UserSlug[0]
        : resolvedParams.UserSlug;
    return <AdminBrandDetail userSlug={userSlug} />;
};

export default AdminBrandDetailsPage;
